// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/QuestionForm.test.tsx

/** The selected-option text QuestionForm puts after `**Header:**`. */
export function questionOptionAnswerText(option: {
  label: string;
  value?: string;
}): string {
  // why: a blank value is "no value" on the wire — QuestionForm already skips it
  return option.value
    ? `${option.label} (selection: ${option.value})`
    : option.label;
}

/** One line of a question-form submit. The thread sends this string as the next message. */
export function formatQuestionFormAnswerLine(
  header: string,
  answer: string,
): string {
  return `**${header}:** ${answer}`;
}
